module.exports = __webpack_public_path__ + "static/media/loader-cashx.75ae2ba2.gif";